export class MaterialExt {
  static readonly TRANSPARENCY_MODE_OPAQUE = 0;
  static readonly TRANSPARENCY_MODE_ALPHATEST = 1;
  static readonly TRANSPARENCY_MODE_ALPHABLEND = 2;
  static readonly TRANSPARENCY_MODE_ALPHATESTANDBLEND = 3;
}
